// src/screens/customer/customerPannel/helpsupport/HelpSupport.jsx

import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Mail,
  Send,
  CheckCircle,
  MessageCircle,
  ChevronRight,
} from "lucide-react";
import "../../../../assets/css/customer/customerPannel/helpsupport/HelpSupport.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const CATEGORY_OPTIONS = [
  { value: "", label: "Select a category" },
  { value: "Order Issue", label: "Order Issue" },
  { value: "Delivery Problem", label: "Delivery Problem" },
  { value: "Product Question", label: "Product Question" },
  { value: "Payment Issue", label: "Payment Issue" },
  { value: "Return / Refund", label: "Return / Refund" },
  { value: "Technical Support", label: "Technical Support" },
  { value: "General Inquiry", label: "General Inquiry" },
];

const STATUS_COLOR = {
  Pending: "#d97706",
  Open: "#2563eb",
  Resolved: "#16a34a",
  Closed: "#6b7280",
};

const HelpSupport = () => {
  const { baseUrl, authToken, loggedInCustomer } = useContext(AppContext);
  const navigate = useNavigate();

  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [tickets, setTickets] = useState([]);

  const viewAllTickets = () => {
    axios
      .get(`${baseUrl}/customer/help-support/myTickets`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        setTickets(response.data.tickets);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllTickets();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!category || !message.trim()) return;

    setSubmitting(true);
    const formdata = new FormData();
    formdata.append("category", category);
    formdata.append("message", message);
    formdata.append("status", "pending");
    formdata.append("adcustomer_id", loggedInCustomer.id);

    axios
      .post(`${baseUrl}/customer/help-support/createTicket`, formdata, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then(() => {
        console.log();
        viewAllTickets();
        setCategory("");
        setMessage("");
        Swal.fire({
          title: "Ticket Submitted",
          text: "We'll get back to you within 24 hours.",
          icon: "success",
          confirmButtonColor: "#D67E43",
          confirmButtonText: "OK",
        });
      })
      .catch(console.error)
      .finally(() => setSubmitting(false));
  };

  const openChat = (ticket) => {
    console.log("opening Ticket id", ticket.id);
    console.log("opening Ticket id", ticket.adconversation.id);
    navigate(`/customer/help-support/chat/${ticket.adconversation.id}`);
  };

  return (
    <div className="hs-page">
      {/* Header */}
      <div className="hs-header">
        <div className="hs-header-icon">
          <MessageCircle size={20} strokeWidth={1.8} />
        </div>
        <div>
          <h1 className="hs-title">Help &amp; Support</h1>
          <p className="hs-subtitle">We're here to help</p>
        </div>
      </div>

      {/* Contact Strip */}
      <div className="hs-contact-strip">
        <div className="hs-contact-item">
          <Mail size={15} color="#D67E43" strokeWidth={1.8} />
          <span>adfurniturehouse347@gmail.com</span>
        </div>
        <div className="hs-divider" />
        <div className="hs-contact-item">
          <CheckCircle size={15} color="#5C6B47" strokeWidth={1.8} />
          <span>Response within 24 hrs</span>
        </div>
      </div>

      {/* Submit Ticket */}
      <div className="hs-card">
        <div className="hs-card-label">
          <Send size={14} strokeWidth={2} />
          New Ticket
        </div>

        <form onSubmit={handleSubmit} className="hs-form">
          <div className="hs-field">
            <label className="hs-label">Category</label>
            <select
              className="hs-select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              {CATEGORY_OPTIONS.map((o) => (
                <option key={o.value} value={o.value} disabled={o.value === ""}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>

          <div className="hs-field">
            <label className="hs-label">Message</label>
            <textarea
              className="hs-textarea"
              rows={5}
              placeholder="Describe your issue..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="hs-btn-submit" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit Ticket"}
          </button>
        </form>
      </div>

      {/* Submitted Tickets */}
      {tickets.length > 0 && (
        <div className="hs-card">
          <div className="hs-card-label">
            <CheckCircle size={14} strokeWidth={2} />
            Your Tickets ({tickets.length})
          </div>

          <div className="hs-ticket-list">
            {tickets.map((t) => (
              <div className="hs-ticket" key={t.id}>
                <div className="hs-ticket-top">
                  <span className="hs-ticket-id">{"TKT-" + t.id}</span>
                  <span
                    className="hs-ticket-status"
                    style={{ color: STATUS_COLOR[t.status] || "#6b7280" }}
                  >
                    {t.status}
                  </span>
                </div>

                <div className="hs-ticket-meta">
                  <span className="hs-ticket-tag">{t.category}</span>
                  {t.date && <span className="hs-ticket-date">{t.date}</span>}
                </div>

                <p className="hs-ticket-msg">{t.message}</p>

                <div className="hs-ticket-footer">
                  <button
                    className="hs-chat-trigger"
                    onClick={() => openChat(t)}
                    title="Open chat for this ticket"
                  >
                    <MessageCircle size={14} strokeWidth={2} />
                    Chat
                    <ChevronRight size={13} strokeWidth={2} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpSupport;
